module.exports = __webpack_public_path__ + "static1792652164348/img/logo.6fd59d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 413
// module chunks = 116